<template>
  <vue-slider v-bind="options" tooltip="none" />
</template>

<script setup lang="ts">
import vueSlider from "vue-3-slider-component";

const options = {
  dotStyle: {
    backgroundColor: "white",
    borderColor: "#3769D6",
    borderWidth: "4px",
  },
  railStyle: {
    backgroundColor: "#EBEEF5",
    height: " 8px",
  },
  processStyle: {
    backgroundColor: "#3769D6",
    height: " 8px",
  },
};
</script>
